<template>
  <div class="row">
    <div
      v-for="(card, index) in selectedTabName === brand
        ? filteredTrayData
        : TrayData"
      :key="card.title"
      class="board-card p-0"
      :class="
        layoutToRenderIsSmall
          ? 'small-list--my-tray'
          : 'large-list--my-tray'
      "
    >
      <div class="card border-0 card">
        <div class="card-body p-0">
          <div class="col-12 d-flex justify-content-end pr-0"
          v-if="selectedTabName.toLowerCase() != shared.toLowerCase()">
            <div class="custom-control">
              <input
                type="checkbox"
                :id="'board-card' + index"
                class="custom-control-input"
                @click="projectSelected(card.id)"
              />
              <label
                :for="'board-card' + index"
                class="custom-control-label"
              ></label>
            </div>
            <div class="btn-group" v-if="selectedTabName !== archived">
              <pc-dropdown-action
                :card="card"
                :selectedProjectId="selectedProjectId"
                :isAdminMode="isAdminMode"
              ></pc-dropdown-action>
            </div>
          </div>
            <div class="image-grid-wrapp-mt-tray">
              <div
                :class="
                  layoutToRenderIsSmall
                    ? 'image-grid-my-tray-small'
                    : 'image-grid-my-tray-large'">
                <picture
                  class="w-100 position-relative d-block h-100"
                >
                  <img
                    v-if="card.coverPhoto"
                    :src="card.coverPhoto"
                    class="my-tray-thumnial-image h-100"
                    :class="
                      layoutToRenderIsSmall
                        ? 'my-tray-image-small'
                        : 'my-tray-image-large'
                    "
                    :alt="card.title || ''"
                  />
                </picture>
                <div
                  class="top-left-publish-unpublish"
                  v-if="selectedTabName === brand && isAdminMode"
                >
                  <span class="font-16">
                    {{
                    card.brandBoardStatus === 0 ? $resourceString["common.accounts.Unpublished.Msg"]  : card.brandBoardStatus === 1 ? $resourceString["common.accounts.Draft.Msg"] :  $resourceString["common.accounts.Published.Msg"]
                    }}
                  </span>
                </div>
              </div>
              <div class="on-hover-background-card">
                <a
                  :href="`/Project/Edit/${card.id}`"
                  ref="goToEditTray"
                  class="btn btn-outline-white-warn btn btn-outline-primary"
                  rel="noopener"
                  >{{ $resourceString["myProject.Project.GoToProject.Msg"] }}</a
                >
              </div>
            </div>
          <div class="col-12 pl-0">
            <div class="">
              <a
              :href="`/Project/Edit/${card.id}`"
                class="card-title text-size-normal black text-decoration-none my-2 card-title-myProject project-title"
              >
                {{ card.title }}
              </a>
            </div>
            <div class="">
              <span class="card-createdAt-MyProject">
                {{
                  new Date(card.createdAt).toLocaleDateString("en-US", {
                    day: "numeric",
                    month: "numeric",
                    year: "2-digit"
                  })
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12" v-if="TrayData.length == 0 && !showLoadMore">
      <div class="text-center mt-4">
        <p>{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import pcDropdownAction from "./pc-dropdown-action.vue";

export default {
  mounted() {
    this.updateSelectedProjectId([]);
  },
  props: ["layoutToRenderIsSmall", "isAdminMode"],
  data() {
    return {
      selectedProjectId: [],
      editTrayId: "",
      brand: this.$resourceString['common.accounts.Label.Brand'],
      shared: this.$resourceString['common.accounts.Label.Shared'],
      archived: this.$resourceString['common.accounts.Label.Archived'],
    };
  },
  components: {
    pcDropdownAction
  },

  computed: {
    ...mapGetters({
      TrayData: "myTray/getAllVirtualTrayBoardData",
      selectedTabName: "myTray/getselectedTabName",
      getSelectedProjectId: "myTray/getSelectedTrayId",
      showLoadMore: "myTray/showLoadMore"
    }),

    showHideEdit() {
      return this.selectedProjectId.length <= 1;
    },

    isDisabled() {
      return this.selectedProjectId.length === 0;
    },

    filteredTrayData() {
      if (!this.isAdminMode) {
        return this.TrayData.filter(card => card.brandBoardStatus !== 0);
      } else {
        return this.TrayData;
      }
    }
  },
  watch: {
    getSelectedProjectId() {
      this.selectedProjectId = this.getSelectedProjectId;
    }
  },
  methods: {
    ...mapActions({
      deleteVirtualTray: "myTray/deleteVirtualTray",
      archiveVirtualTray: "myTray/archiveVirtualTray",
      updateSelectedProjectId: "myTray/updateSelectedTrayId",
      getUserTrayIdApiDetails: "myTray/getUserTrayIdApiDetails",
      updateShareTrayIfFromMyTrayPage: "myTray/updateShareTrayIfFromMyTrayPage",
      virtualTrayEdit: "myTray/virtualTrayEdit",
      publishTrayApi: "myTray/publishTrayApi",
      unpublishTrayApi: "myTray/unpublishTrayApi",
      archiveResourceString: "myTray/archiveResourceString",
      resourceString: "myTray/resourceString",
      modalArchiveMsg: "myTray/modalArchiveMsg"
    }),

    projectSelected(id) {
      let checkIfExists = this.selectedProjectId.indexOf(id);
      if (checkIfExists >= 0) {
        this.selectedProjectId.splice(checkIfExists, 1);
      } else {
        this.selectedProjectId.push(id);
      }
      this.updateSelectedProjectId(this.selectedProjectId);
    },

    async handleArchiveTray() {
      await this.modalArchiveMsg("");
      await this.archiveResourceString(
        this.$resourceString["common.accounts.Archived.Msg"]
      );
      await this.archiveVirtualTray(this.selectedProjectId);
    },

    async handleDeleteTray() {
      await this.resourceString(
        this.$resourceString["common.accounts.Deleted.Msg"]
      );
      await this.deleteVirtualTray(this.selectedProjectId);
    },

    showModal(name) {
      this.$modal.show(name + "-modal");
    },

    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },

    shareTray(id) {
      this.updateShareTrayIfFromMyTrayPage(id);
      this.showModal("share-tray");
      let data = {
        boardId: id ? id : ""
      };
      this.getUserTrayIdApiDetails(data);
    },

    async publishTray(id) {
      let data = {
        id: id
      };
      await this.resourceString(
        this.$resourceString["common.Published.Msg"]
      );
      await this.publishTrayApi(data);
    },

    async unpublishTray(id) {
      let data = {
        id: id
      };
      await this.resourceString(
        this.$resourceString["common.Unpublished.Msg"]
      );
      await this.unpublishTrayApi(data);
    }
  }
};
</script>
